const formattedLabelValue = (value) => {
  const formatMillions = 1000000;
  const formatThousand = 1000;

  if (value >= formatMillions) {
    const formattedValue = value / formatMillions;
    return `${formattedValue}M`;
  }

  if (value >= formatThousand) {
    const formattedValue = value / formatThousand;
    return `${formattedValue}K`;
  }

  return value;
};

export default formattedLabelValue;
